import { Common, ApiBind } from './common.model';

export class Page extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;
}
